// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/legacy/style.scss
// module id = 19
// module chunks = 0